<div class="textinput__input">
  <input type="number" [id]="fp.id" name="" [(ngModel)]="value" (blur)="onBlur()" (keydown)="onKeydown($event)">
</div>
